<div class="pet-tile-review-container">
  <div class="lato bold mt-1">
    {{ petInfo.firstName + " " + petInfo.lastName }}
  </div>
  <div class="pet-info-table">
    <div *ngFor="let vaccine of petInfo.vaccines" class="row no-gutters">
      <div class="pet-info-label pr-2 primary">{{ vaccine.vaccine?.name }}</div>
      <div class="pet-tile-review-content primary">
        {{ vaccine.expiresOn | date }}
      </div>
    </div>
  </div>
  <div class="pet-tile-review-content" style="white-space: pre-wrap"></div>
</div>
